import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, Injector } from '@angular/core';
// import { RouterStateTrackerService } from 'src/app/services/router-state-tracker.service';
import { BasePage } from 'src/app/shared/base-page';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  standalone: false,
})
export class AppHeaderComponent extends BasePage implements OnInit, OnDestroy {

  @Input() headerSize: boolean = false;

  @Input() backRoute: string = '';

  @Input() pageTitle: string = '';

  @Output() activeTitle = new EventEmitter<boolean>();

  headerAnim: string = 'enterTop';

  activeTitleVar: boolean = true; // Default to 'unread'

  constructor( 
    injector: Injector,
    // public override routerStateTrackerService: RouterStateTrackerService
  ) {
    super(injector);
    this.animationDuration = 500;
    this.useIntersectionObserver = false;
  }

  override async ngAfterViewInit(): Promise<void> {
    this.resetHeaderAnimations();
  }

  private resetHeaderAnimations(): void {
    this.animClassTop = 'enterTop';
    this.smallHeader = `smallHeader ${this.animClassTop}`;
    this.bigHeader = `bigHeader ${this.animClassTop}`;
    this.headerAnim = 'enterTop';
  }

  ngOnInit(): void {
    this.activeTitleVar = true;
  }

  override async navigateToPage(page: string, data: any = { test: 'from header' }): Promise<void> {
    await super.navigateToPage(page, data);
  }

  public override async playPreExitAnimation(): Promise<void> {
    this.activeTitleVar = true; // Reset or set to a default for exit
    await super.playPreExitAnimation();
  }
}
